import { Injectable } from '@angular/core';
import { IActivityAuthDto, IAuthDto } from 'core/dto';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { controllerEndpoints } from '../controller.endpoints';
import joinUrls from '../utils.ts/join-urls';

const methodPaths = {
  CODE_PATH: 'code',
  SMS_PATH: 'otp',
  SXS_PATH: 'sxs',
  SEND_SMS_OTP_PATH: 'sendOtp',
  OIDC_PATH: 'oidcLogin'
} as const


@Injectable({
  providedIn: 'root'
})
export class ActivityAuthRemoteControllerService {

  private readonly _endpoint = controllerEndpoints.ACTIVITY_AUTH;

  private readonly GET_AUTH_FOR_ACTIVITY = 'getAuthForActivity' as const
  private readonly CONFIGURE = 'configure'
  private readonly WITHOUT_AUTH = 'withoutAuthentication'
  constructor(
    private readonly _apiService: ApiService
  ) {
  }

  code(params: { code: string, activityId: string, }): Observable<IAuthDto> {
    const codeEndpoint = joinUrls(this._endpoint, methodPaths.CODE_PATH);
    return this._apiService.post(codeEndpoint, params)
  }

  sendSmsOtp(activityId: string,) {
    const sendSmsEndpoint = joinUrls(this._endpoint, methodPaths.SEND_SMS_OTP_PATH);
    return this._apiService.post(sendSmsEndpoint, { activityId }, undefined,)
  }

  sms(params: { otp: string, activityId: string, }): Observable<IAuthDto> {
    const smsEndpoint = joinUrls(this._endpoint, methodPaths.SMS_PATH);
    return this._apiService.post(smsEndpoint, params)
  }

  sxs(params: { otp: string, activityId: string }): Observable<IAuthDto> {
    const sxsEndpoint = joinUrls(this._endpoint, methodPaths.SXS_PATH);
    return this._apiService.post(sxsEndpoint, params)
  }

  oidc(params: { configId: string, activityId: string }): Observable<{ redirectUri: string }> {
    const oidcEndpoint = joinUrls(this._endpoint, methodPaths.OIDC_PATH);
    return this._apiService.get(oidcEndpoint, params)
  }

  getAuthForActivity(params: { activityId: string }): Observable<{ id: number, name: string }[]> {
    const getAuthForActivityEndpoint = joinUrls(this._endpoint, this.GET_AUTH_FOR_ACTIVITY);
    return this._apiService.get(getAuthForActivityEndpoint, params)
  }

  configure(params: IActivityAuthDto[]) {
    const configureEndpoint = joinUrls(this._endpoint, this.CONFIGURE)
    return this._apiService.post(configureEndpoint, params)
  }

  getConfiguredAuths(activityId: string): Observable<IActivityAuthDto[]> {
    const getConfiguredEndpoint = joinUrls(this._endpoint, this.CONFIGURE, activityId);
    return this._apiService.get(getConfiguredEndpoint);
  }

  withoutAuth(activityId: string): Observable<IAuthDto> {
    const withoutAuthEndpoint = joinUrls(this._endpoint, this.WITHOUT_AUTH);
    return this._apiService.post(withoutAuthEndpoint, { activityId });
  }
}
